import { createSelector } from 'reselect';
import { getScopes } from './getScopes';
export const hasSLAAlertsAccess = createSelector(getScopes, scopes => scopes.includes('sla-alerts-access'));